import { Component, OnInit, Input, SimpleChanges, OnChanges } from "@angular/core";
import {
  bankLinkStatusLabels,
  FinancialInstitution,
  InstitutionIntegrationStatus,
  BankAccountRole
} from "../../bank-account/bank-account.model";
import { BankingService } from "../../bank-account/banking.service";
import { EntityExData } from "common";

@Component({
    selector: "ifp-dashboard-bank-widget",
    templateUrl: "./bank-widget.component.html",
    styleUrls: ["./bank-widget.component.scss"],
    standalone: false
})
export class DashboardBankWidgetComponent implements OnInit, OnChanges {
  @Input() bank: FinancialInstitution;
  @Input() entity: EntityExData;

  institutionIntegrationStatus: InstitutionIntegrationStatus;
  isPaymentInstitution: boolean;
  isDisbursementInstitution: boolean;

  readonly bankLinkStatusLabels = bankLinkStatusLabels;
  readonly BankAccountRole = BankAccountRole;

  constructor(private _bankingService: BankingService) {}

  ngOnInit() {
    this.institutionIntegrationStatus = this.bank.isLinked
      ? InstitutionIntegrationStatus.Linked
      : InstitutionIntegrationStatus.Unlinked;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.bank) {
      const role = this.bank?.role;
      this.isDisbursementInstitution = role === BankAccountRole.Disbursement || role === BankAccountRole.PaymentAndDisbursement;
      this.isPaymentInstitution = role === BankAccountRole.Payment || role === BankAccountRole.PaymentAndDisbursement;
    }
  }

  relink() {
    this._bankingService.relink(this.entity.id, this.bank);
  }
}
